fx.ns("shared.stage", class CoverBinding extends fx.Component {

    constructor(creation, page) {
        super();

        this.creation = creation;
        this.page = page;
        this.pointerEvents = false;
    }



    onReady() {
        super.onReady()

        if (this.page && this.page.isCover)
            this.addClass("cover");// type;

        this._updateSlice();
    }

    onDataEvent(e) {
        if (e.type == "cover-updated") {
            this.update();
            this._updateSlice()
        }

    }

    _updateSlice() {
        if (this.page && this.page.isCover && this.creation.hasSlice)
            this.toolTip = this.creation.sliceText;

        this.attr("covertype", this.creation.cover_option);
    }

    render() {
        let html = '<div class="content">';

        if (this.creation) {
            if (this.creation.cover_option == models.ProductBook.BIND) {
                if (this.page && this.page.isCover)
                    html += '<div class="bind-container"><div class="bind"></div></div><div class="bind-container"><div class="bind"></div></div>';
            }
            else
                if (this.creation.cover_option == models.ProductBook.SPIRAL) {
                    let numberSpirals;
                    switch (this.creation.shape_option) {
                        case "square":
                            numberSpirals = 16;
                            break;
                        case "landscape":
                            numberSpirals = 16;
                            break;
                        case "portrait":
                        default:
                            numberSpirals = 23;
                            break;
                    }

                    for (let i = 0; i < numberSpirals; i++)
                        html += '<div class="element"><div class="whole left"></div><div class="arc"></div><div class="whole right"></div></div>';
                }
                else
                    if (this.creation.cover_code.startsWith("CALENDAR")) {
                        let asset;

                        if (this.creation.cover_option == "wall-single")
                            asset = fx.assets.calendarWallSingle;
                        else
                            if (this.creation.cover_option == "wall-double") {
                                if (this.page.isCover)
                                    asset = fx.assets.calendarWallDoubleCover;
                                else
                                    asset = fx.assets.calendarWallDoublePages;
                            }
                            else
                                if (this.creation.cover_option == "desk")
                                    asset = fx.assets.calendarDesk;

                        html += '<div class="element ' + this.creation.cover_option + '">' + asset.render() + '</div>';
                    }

        }

        html += '</div>';
        return html;
    }

});